import { useEffect, useState } from "react";
import { CoreMenuItem, CoreSelect } from "@verity/components/core";
import { CustomSettingData } from "../../settings-page";
import i18n from "../../../../i18n";

export type Language = "en" | "fr";

const isValidLanguage = (value: unknown): value is Language => {
	return value === "en" || value === "fr";
};

export const LanguageSetting = (props: {
	loadData: Language;
	setting: CustomSettingData<Language>;
	onSettingChange: (value: Language) => void;
}) => {
	const [language, setLanguage] = useState<Language>(props.setting.value ?? props.loadData);
	useEffect(() => {
		props.onSettingChange(language);
	}, [language, props]);

	const languageNames: Record<Language, string> = {
		en: i18n.t("language.English", { lng: "en" }),
		fr: i18n.t("language.French", { lng: "fr" }),
	};

	return (
		<CoreSelect
			label={languageNames[language]}
			value={language}
			renderValue={(value) => <div style={{ paddingRight: "60px" }}>{languageNames[value]}</div>}
			onChange={(event) => {
				if (isValidLanguage(event.target.value)) setLanguage(event.target.value);
			}}
		>
			<CoreMenuItem value={"en"}>{languageNames["en"]}</CoreMenuItem>
			<CoreMenuItem value={"fr"}>{languageNames["fr"]}</CoreMenuItem>
		</CoreSelect>
	);
};
